var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { STREAMING_TYPE } from "./IQuoteStreamRepo";
import QuoteRequestMapper from "./QuoteRequestMapper";
import QuoteResponseMappper from "./QuoteResponseMappper";
import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
export var StreamingSectionName;
(function (StreamingSectionName) {
    StreamingSectionName["Header"] = "Header";
    StreamingSectionName["EQ_MarketToday"] = "EQ_MarketToday";
    StreamingSectionName["EQ_MarketStatus"] = "EQ_MarketStatus";
    StreamingSectionName["EQ_IndicesHL"] = "EQ_IndicesHL";
    StreamingSectionName["EQ_IndicesHL_ViewAll"] = "EQ_IndicesHL_ViewAll";
    StreamingSectionName["EQ_AdvanceDecline"] = "EQ_AdvanceDecline";
    StreamingSectionName["EQ_AdvanceDecline_ViewAll"] = "EQ_AdvanceDecline_ViewAll";
    StreamingSectionName["EQ_AdvanceDecline_Quote_ViewAll"] = "EQ_AdvanceDecline_Quote_ViewAll";
    StreamingSectionName["EQ_MarkekMap"] = "EQ_MarkekMap";
    StreamingSectionName["EQ_SectoralPerformance"] = "EQ_SectoralPerformance";
    StreamingSectionName["EQ_DrivingMarket"] = "EQ_DrivingMarket";
    StreamingSectionName["EQ_TOP_LOOSERS"] = "EQ_TopLoosers";
    StreamingSectionName["EQ_TOP_GAINERS"] = "EQ_TopGainers";
    StreamingSectionName["EQ_INDEX_PULLERS"] = "EQ_IndexPullers";
    StreamingSectionName["EQ_INDEX_DRAGGERS"] = "EQ_IndexDraggers";
    StreamingSectionName["EQ_ALL_HIGH"] = "EQ_AllHigh";
    StreamingSectionName["EQ_ALL_Low"] = "EQ_AllLow";
    StreamingSectionName["EQ_52_WEEK_HIGH"] = "EQ_52_Week_High";
    StreamingSectionName["EQ_52_WEEK_LOW"] = "EQ_52_Week_Low";
    StreamingSectionName["EQ_PRICE_BUZZERS"] = "EQ_Price_Buzzers";
    StreamingSectionName["EQ_VOLUME_BUZZERS"] = "EQ_Volume_Buzzers";
    StreamingSectionName["EQ_UPPER_CIRCUIT"] = "EQ_Upper_Circuit";
    StreamingSectionName["EQ_LOWER_CIRCUIT"] = "EQ_Lower_Circuit";
    StreamingSectionName["EQ_OUTPERFORM"] = "EQ_Outperform";
    StreamingSectionName["EQ_UNDERPERFORM"] = "EQ_Underperform";
    StreamingSectionName["EQ_DrivingMarket_ViewAll"] = "EQ_DrivingMarket_ViewAll";
    StreamingSectionName["OP_DrivingMarket_ViewAll"] = "OP_DrivingMarket_ViewAll";
    StreamingSectionName["OP_HIGHEST_OI_GAINERS"] = "OP_HIGHEST_OI_GAINERS";
    StreamingSectionName["OP_HIGHEST_OI_LOOSERS"] = "OP_HIGHEST_OI_LOOSERS";
    StreamingSectionName["OP_HIGHEST_OI"] = "OP_HIGHEST_OI";
    StreamingSectionName["OP_HIGHEST_OI_VOLUME"] = "OP_HIGHEST_OI_VOLUME";
    StreamingSectionName["NEW_STREAMING"] = "NEW_STREAMING";
    StreamingSectionName["FUT_MarketToday"] = "FUT_MarketToday";
    StreamingSectionName["FUT_OI_Analysis_ViewAll"] = "FUT_OI_Analysis_ViewAll";
    StreamingSectionName["FUT_DrivingMarket_ViewAll"] = "FUT_DrivingMarket_ViewAll";
    StreamingSectionName["FUT_Long_BuildUp"] = "FUT_Long_BuildUp";
    StreamingSectionName["FUT_Short_Covering"] = "FUT_Short_Covering";
    StreamingSectionName["FUT_Long_Unwinding"] = "FUT_Long_Unwinding";
    StreamingSectionName["FUT_Short_BuildUp"] = "FUT_Short_BuildUp";
    StreamingSectionName["FUT_Highest_OI_Gainers"] = "FUT_Highest_OI_Gainers";
    StreamingSectionName["FUT_Highest_OI_Losers"] = "FUT_Highest_OI_Losers";
    StreamingSectionName["FUT_Active_Volume"] = "FUT_Active_Volume";
    StreamingSectionName["FUT_Active_Value"] = "FUT_Active_Value";
    StreamingSectionName["FUT_Highest_Rollover"] = "FUT_Highest_Rollover";
    StreamingSectionName["FUT_Lowest_Rollover"] = "FUT_Lowest_Rollover";
    StreamingSectionName["FUT_Top_Gainers"] = "FUT_Top_Gainers";
    StreamingSectionName["FUT_Top_Losers"] = "FUT_Top_Losers";
    StreamingSectionName["FUT_Highest_Premium"] = "FUT_Highest_Premium";
    StreamingSectionName["FUT_Highest_Discount"] = "FUT_Highest_Discount";
    StreamingSectionName["FUT_MarketStatus"] = "FUT_MarketStatus";
    StreamingSectionName["Common_SideBar"] = "Common_SideBar";
    StreamingSectionName["Market_Depth_Common_SideBar"] = "Market_Depth_Common_SideBar";
    StreamingSectionName["SEARCH"] = "SEARCH";
    StreamingSectionName["ETF_MAIN"] = "ETF_MAIN";
    StreamingSectionName["OPTION_CHAIN"] = "OPTION_CHAIN";
    StreamingSectionName["NEWS"] = "news";
    StreamingSectionName["FOOTERSTATUS"] = "Footer_Status";
    StreamingSectionName["ALERTS"] = "alerts";
    StreamingSectionName["CALENDAR"] = "calendar";
    StreamingSectionName["REPORTS_PNL"] = "Reports_PNL";
    StreamingSectionName["REPORTS_DASHBOARD_PNL"] = "Reports_Dashboard_PNL";
    StreamingSectionName["REPORTS_HOLDINGS"] = "Reports_Holdings";
    StreamingSectionName["REPORTS_POSITIONS"] = "Reports_POSITIONS";
    StreamingSectionName["WATCHLIST"] = "WatchList";
    StreamingSectionName["WATCHLISTGLOBALPIN"] = "WatchListGlobalPin";
    StreamingSectionName["INDICES_QUOTES_OVERVIEW"] = "Indices_Quotes_Overview";
    StreamingSectionName["ETF_QUOTES_OVERVIEW"] = "ETF_QUOTES_OVERVIEW";
    StreamingSectionName["EQUITY_QUOTES_OVERVIEW"] = "EQUITY_QUOTES_OVERVIEW";
    StreamingSectionName["Index_Constituents"] = "Index_Constituents";
    StreamingSectionName["ETF_ScreenStream"] = "ETF_ScreenStream";
    StreamingSectionName["INDICES_LIVENEWS"] = "INDICES_LIVENEWS";
    StreamingSectionName["INDICES_ADVDEC"] = "INDICES_ADVDEC";
    StreamingSectionName["INDICES_ACTVOL"] = "INDICES_ACTVOL";
    StreamingSectionName["INDICES_ACTVALUE"] = "INDICES_ACTVALUE";
    StreamingSectionName["OPTIONS_OVERVIEW"] = "OPTIONS_OVERVIEW";
    StreamingSectionName["PEER_COMPANIES_FUTURES_QUOTES"] = "PEER_COMPANIES_FUTURES_QUOTES";
    StreamingSectionName["Commodity_MCX_STREAMING"] = "Commodity_MCX_STREAMING";
    StreamingSectionName["REPORTS_ACCOUNT_OVERVIEW"] = "Reports_Account_Overview";
    StreamingSectionName["POSITION_REVAMP"] = "POSITION_REVAMP";
})(StreamingSectionName || (StreamingSectionName = {}));
var QuoteStreamRepo = /** @class */ (function () {
    function QuoteStreamRepo(stream, sharedWorker) {
        this.stream = stream;
        this.sharedWorker = sharedWorker;
        this.requestMapper = new QuoteRequestMapper();
        this.responseMapper = new QuoteResponseMappper();
        this.callback = new Map();
        this.symbols = [];
        this.symbolsMini = [];
        this.advanceDeclineSymbol = [];
        this.activeClient = true;
        this.clientId = undefined;
        this.symSectionManage = function (symbols, sectionName, symbol_sectionList, subscribe) {
            var sType = JSON.parse(JSON.stringify(symbol_sectionList));
            symbols.forEach(function (x) {
                if (subscribe) {
                    if (sType.hasOwnProperty(x)) {
                        if (!sType[x].includes(sectionName)) {
                            sType[x].push(sectionName);
                        }
                    }
                    else {
                        sType[x] = [sectionName];
                    }
                }
                else {
                    if (sType.hasOwnProperty(x)) {
                        var index = sType[x].indexOf(sectionName);
                        if (index > -1) {
                            sType[x].splice(index, 1);
                        }
                        if (sType[x].length === 0) {
                            delete sType[x];
                        }
                    }
                }
            });
            return sType;
        };
        this.checkSubset = function (parentArray, subsetArray) {
            return subsetArray.every(function (el) {
                return parentArray.includes(el);
            });
        };
        this.getsybolslist = function (srJson, streaming_type) {
            var list = [];
            Object.values(srJson).map(function (z) {
                if (z[streaming_type]) {
                    Object.keys(z[streaming_type]).map(function (x) {
                        if (!list.includes(x)) {
                            list.push(x);
                        }
                    });
                }
            });
            return list;
        };
    }
    QuoteStreamRepo.prototype.activeScreen = function (active) {
        this.activeClient = active;
        if (this.sharedWorker && this.clientId !== undefined) {
            this.stream.port.postMessage({
                type: "active",
                clientId: this.clientId,
                req: active,
            });
        }
    };
    QuoteStreamRepo.prototype.streamQuote = function (streaming_type, subscribe, cb, symbols, streamKey, sectionName) {
        var _this = this;
        try {
            if (symbols.length > 0 ||
                streaming_type === STREAMING_TYPE.NEWS ||
                streaming_type === STREAMING_TYPE.MARKET_STATUS) {
                if (this.sharedWorker) {
                    var msgReadyToSend_1 = false;
                    var waitingForConn_1 = setInterval(function () {
                        if (!msgReadyToSend_1 && _this.clientId !== undefined) {
                            _this.manageStreamArray(subscribe, streamKey, cb, symbols, streaming_type === STREAMING_TYPE.QUOTE
                                ? _this.symbols
                                : streaming_type === STREAMING_TYPE.MINIQUOTE
                                    ? _this.symbolsMini
                                    : streaming_type === STREAMING_TYPE.ADVDEC
                                        ? _this.advanceDeclineSymbol
                                        : symbols, streaming_type, sectionName);
                            if (streaming_type !== STREAMING_TYPE.MARKET_STATUS ||
                                (streaming_type === STREAMING_TYPE.MARKET_STATUS && subscribe)) {
                                var req = _this.requestMapper.formatRequest(streaming_type === STREAMING_TYPE.QUOTE
                                    ? _this.symbols
                                    : streaming_type === STREAMING_TYPE.MINIQUOTE
                                        ? _this.symbolsMini
                                        : streaming_type === STREAMING_TYPE.ADVDEC
                                            ? _this.advanceDeclineSymbol
                                            : symbols, streaming_type === STREAMING_TYPE.QUOTE ||
                                    streaming_type === STREAMING_TYPE.MINIQUOTE ||
                                    streaming_type === STREAMING_TYPE.MARKET_STATUS
                                    ? true
                                    : subscribe, streaming_type);
                                _this.stream.port.postMessage({
                                    type: "send",
                                    req: req,
                                });
                            }
                            msgReadyToSend_1 = true;
                            clearInterval(waitingForConn_1);
                        }
                    }, 0);
                }
                else {
                    this.manageStreamArray(subscribe, streamKey, cb, symbols, streaming_type === STREAMING_TYPE.QUOTE
                        ? this.symbols
                        : streaming_type === STREAMING_TYPE.MINIQUOTE
                            ? this.symbolsMini
                            : streaming_type === STREAMING_TYPE.ADVDEC
                                ? this.advanceDeclineSymbol
                                : symbols, streaming_type, sectionName);
                }
                if (subscribe) {
                    var req = this.requestMapper.formatRequest(streaming_type === STREAMING_TYPE.QUOTE
                        ? this.symbols
                        : streaming_type === STREAMING_TYPE.MINIQUOTE
                            ? this.symbolsMini
                            : streaming_type === STREAMING_TYPE.ADVDEC
                                ? this.advanceDeclineSymbol
                                : symbols, streaming_type === STREAMING_TYPE.QUOTE ||
                        streaming_type === STREAMING_TYPE.MINIQUOTE ||
                        streaming_type === STREAMING_TYPE.MARKET_STATUS
                        ? true
                        : subscribe, streaming_type);
                    if (this.sharedWorker) {
                        this.stream.port.onmessage = function (event) {
                            var _a = event.data, type = _a.type, message = _a.message, clientId = _a.clientId, clients = _a.clients;
                            if (type == "connected") {
                                _this.clientId = clientId;
                            }
                            else if (type == "message") {
                                _this.streamRespCallback(message);
                            }
                            else if (type === "deleteClientId") {
                                var streaming_request_1 = JSON.parse(localStorage.getItem("streaming_request"));
                                Object.keys(streaming_request_1).map(function (x) {
                                    if (!clients.includes(x)) {
                                        delete streaming_request_1[x];
                                    }
                                });
                                localStorage.setItem("streaming_request", JSON.stringify(streaming_request_1));
                            }
                        };
                    }
                    else {
                        var reqPayload = {
                            payload: req,
                            message: function (e) {
                                if (_this.activeClient)
                                    _this.streamRespCallback(e);
                            },
                        };
                        this.stream.WSRequest(reqPayload);
                    }
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    QuoteStreamRepo.prototype.streamTotp = function (userId, userType) {
        var _this = this;
        try {
            var req_1 = JSON.stringify({
                request: {
                    streaming_type: "totp",
                    formFactor: "W",
                    response_format: "json",
                    request_type: "publish",
                    appID: urlConfig.appid,
                    data: {
                        userID: userId,
                        accType: userType,
                    },
                },
                echo: {
                    DESTINATION: "EMT",
                },
            });
            if (this.sharedWorker) {
                var msgReadyToSend_2 = false;
                var waitingForConn_2 = setInterval(function () {
                    if (!msgReadyToSend_2 && _this.clientId !== undefined) {
                        _this.stream.port.postMessage({
                            type: "send",
                            req: req_1,
                        });
                        msgReadyToSend_2 = true;
                        clearInterval(waitingForConn_2);
                    }
                }, 0);
            }
            else {
                var reqPayload = {
                    payload: req_1,
                    message: function () { },
                };
                this.stream.WSRequest(reqPayload);
            }
        }
        catch (error) {
            console.log("mobAppCode", error);
        }
    };
    QuoteStreamRepo.prototype.streamRespCallback = function (e) {
        var _this = this;
        var _a;
        try {
            var ResData = JSON.parse(e).response;
            if (ResData.streaming_type === STREAMING_TYPE.NEWS) {
                this.responseMapper.formatResponse(e, this.callback.get(StreamingSectionName.NEWS));
            }
            else if (ResData.streaming_type === STREAMING_TYPE.MARKET_STATUS) {
                var cb = __spreadArray([], __read(this.callback.values()), false).filter(function (x) { return x.streaming_type === STREAMING_TYPE.MARKET_STATUS; });
                cb &&
                    cb.length > 0 &&
                    cb.forEach(function (x) {
                        _this.responseMapper.formatResponse(e, x);
                    });
            }
            else {
                if (!!this.streaming_request[ResData.streaming_type] &&
                    !!this.streaming_request[ResData.streaming_type][ResData.streaming_type === STREAMING_TYPE.QUOTE2
                        ? ResData.data.symbol
                        : ResData.data.sym]) {
                    (_a = this.streaming_request[ResData.streaming_type][ResData.streaming_type === STREAMING_TYPE.QUOTE2
                        ? ResData.data.symbol
                        : ResData.data.sym]) === null || _a === void 0 ? void 0 : _a.forEach(function (x) {
                        if (_this.callback.get(x)) {
                            _this.responseMapper.formatResponse(e, _this.callback.get(x));
                        }
                    });
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    QuoteStreamRepo.prototype.manageStreamArray = function (subscribe, streamKey, cb, symbols, classSymbols, streaming_type, sectionName) {
        var callback = this.callback.get(sectionName);
        try {
            if (!this.sharedWorker && this.clientId === undefined) {
                this.clientId = "default";
            }
            var streaming_request = localStorage.getItem("streaming_request");
            if (!streaming_request) {
                var sr_stream = {};
                sr_stream[this.clientId] = {};
                sr_stream[this.clientId][streaming_type] = this.symSectionManage(symbols, sectionName, {}, subscribe);
                if (streaming_type === STREAMING_TYPE.MINIQUOTE) {
                    this.symbolsMini = this.getsybolslist(sr_stream, streaming_type);
                }
                if (streaming_type === STREAMING_TYPE.QUOTE) {
                    this.symbols = this.getsybolslist(sr_stream, streaming_type);
                }
                if (streaming_type === STREAMING_TYPE.ADVDEC) {
                    this.advanceDeclineSymbol = this.getsybolslist(sr_stream, streaming_type);
                }
                this.streaming_request = sr_stream[this.clientId];
                localStorage.setItem("streaming_request", JSON.stringify(sr_stream));
            }
            else {
                var srJson = JSON.parse(streaming_request);
                if (!srJson.hasOwnProperty(this.clientId)) {
                    srJson[this.clientId] = {};
                }
                if (!srJson[this.clientId].hasOwnProperty(streaming_type)) {
                    srJson[this.clientId][streaming_type] = {};
                }
                srJson[this.clientId][streaming_type] = this.symSectionManage(symbols, sectionName, srJson[this.clientId][streaming_type], subscribe);
                if (streaming_type === STREAMING_TYPE.MINIQUOTE) {
                    this.symbolsMini = this.getsybolslist(srJson, streaming_type);
                }
                if (streaming_type === STREAMING_TYPE.QUOTE) {
                    this.symbols = this.getsybolslist(srJson, streaming_type);
                }
                if (streaming_type === STREAMING_TYPE.ADVDEC) {
                    this.advanceDeclineSymbol = this.getsybolslist(srJson, streaming_type);
                }
                this.streaming_request = srJson[this.clientId];
                localStorage.setItem("streaming_request", JSON.stringify(srJson));
            }
        }
        catch (error) {
            console.log(error);
        }
        // } else {
        //   symbols?.length &&
        //     symbols.forEach((sym) => {
        //       const indexKey = classSymbols.findIndex((stmKey) => stmKey === sym);
        //       subscribe
        //         ? indexKey === -1 && classSymbols.push(sym)
        //         : [...this.callback.values()]
        //             .map((z: any) => {
        //               if (
        //                 z.symbols.includes(sym) &&
        //                 z.streaming_type === streaming_type
        //               ) {
        //                 return sym;
        //               }
        //             })
        //             .filter((x) => x).length < 2 &&
        //           indexKey > -1 &&
        //           classSymbols.splice(indexKey, 1);
        //     });
        // }
        if (subscribe) {
            this.callback.set(sectionName, {
                sectionName: sectionName,
                cb: cb,
                streamKey: streamKey,
                symbols: symbols,
                streaming_type: streaming_type,
            });
        }
        else {
            if (callback) {
                this.callback.delete(callback.sectionName);
            }
        }
    };
    return QuoteStreamRepo;
}());
export default QuoteStreamRepo;
